import { FC, PropsWithChildren } from "react";
import styles from "./main.module.scss";

const IconLabel: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles.iconWrapper}>
      <div>{children}</div>
    </div>
  );
};

export default IconLabel;
